import apiRequest from './apiRequest';

export type JobExportStatusResponse = {
  downloadExportsReady: boolean;
  expectedExportRequests: number;
  exportRequestCount: number;
  completedExportRequests: number;
  hasFailedExport: boolean;
};

export default async function getJobExportStatus(
  batchID: string,
  jobID: string,
  apiKey: string,
): Promise<JobExportStatusResponse> {
  const { data, error } = await apiRequest<JobExportStatusResponse>(
    'external-mogen',
    `/exports/batches/${batchID}/jobs/${jobID}/status`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
  if (error) throw error;
  return data!;
}
